var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-life"},[_c('div',{staticClass:"bar",class:_vm.calExpiration,style:(("top:" + _vm.expiration + "%")),attrs:{"data-title":(_vm.limit2numbers + " of O2 remains"),"data-title-right":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }